import { toast } from 'react-toastify';
import * as api from '../api/visitPartsApi';
import * as types from '../constants/visitPartsConstants';

export const getVisitPartsActions = (vin, visitId) => async (dispatch) => {
  dispatch({ type: types.GET_VISIT_PARTS_REQUEST });
  try {
    const { error, data } = await api.getVisitParts(vin, visitId);
    if (error) {
      throw new Error(error);
    }

    dispatch({
      type: types.GET_VISIT_PARTS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    toast.error(error?.message ? error.message : 'Не вдалося завантажити список деталей візиту');
    dispatch({ type: types.GET_VISIT_PARTS_FAILURE });
  }
};

export const updateVisitPartAction = (vin, visitId, partId, part) => async () => {
  try {
    const { error } = await api.updateVisitPart(vin, visitId, partId, part);
    if (error) {
      throw new Error(error);
    }
    toast.success('Деталь візиту була успішно змінена');
  } catch (error) {
    toast.error(error?.message ? error.message : 'Не вдалося змінити деталь візиту');
  }
};

export const createVisitPartAction = (vin, visitId, part) => async () => {
  try {
    const { error } = await api.createVisitPart(vin, visitId, part);
    if (error) {
      throw new Error(error);
    }
    toast.success('Деталь візиту була успішно додана');
  } catch (error) {
    toast.error(error?.message ? error.message : 'Не вдалося додати деталь візиту');
  }
};

export const deleteVisitPartAction = (vin, visitId, partId) => async () => {
  try {
    const { error } = await api.deleteVisitPart(vin, visitId, partId);
    if (error) {
      throw new Error(error);
    }
    toast.success('Деталь візиту була успішно видалена');
  } catch (error) {
    toast.error(error?.message ? error.message : 'Не вдалося видалити деталь візиту');
  }
};

export const clearSelectedVisitPartAction = () => async (dispatch) => {
  dispatch({
    type: types.CLEAR_SELECTED_VISIT_PART,
  });
};

export const clearVisitPartsActions = () => async (dispatch) => {
  dispatch({
    type: types.CLEAR_VISIT_PARTS,
  });
};

export const setSelectedVisitPartAction = (part) => async (dispatch) => {
  dispatch({
    type: types.SELECT_VISIT_PART,
    payload: part,
  });
};
